/* Wishlist: header heart and the wishlist page.
   The list itself is kept by theme.js under the same storage key. */
(function () {
  'use strict';

  var KEY = 'mesmo:wishlist';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function root() {
    var value = (window.MESMO && window.MESMO.routes && window.MESMO.routes.root) || '/';
    return value.charAt(value.length - 1) === '/' ? value : value + '/';
  }

  function paintHeader() {
    var filled = read().length > 0;
    all('[data-wish-link]').forEach(function (link) {
      link.classList.toggle('is-active', filled);
    });
  }

  var page = document.querySelector('[data-wishlist]');
  var grid = page && page.querySelector('[data-wishlist-grid]');
  var pending = {};

  function tileFor(handle) {
    return all('[data-wishlist-handle]', grid).filter(function (tile) {
      return tile.getAttribute('data-wishlist-handle') === handle;
    })[0];
  }

  /* A saved product that no longer exists is dropped from the list. */
  function forget(handle) {
    var list = read().filter(function (item) {
      return item !== handle;
    });
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      /* storage unavailable */
    }
    paintHeader();
  }

  function fetchTile(handle) {
    return fetch(root() + 'products/' + encodeURIComponent(handle) + '?section_id=wishlist-item')
      .then(function (response) {
        if (response.status === 404) forget(handle);
        if (!response.ok) throw new Error('Product not available');
        return response.text();
      })
      .then(function (html) {
        var tile = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tile]');
        if (!tile) {
          forget(handle);
          throw new Error('No tile in response');
        }
        var node = document.importNode(tile, true);
        node.setAttribute('data-wishlist-handle', handle);
        var heart = node.querySelector('[data-wish]');
        if (heart) heart.setAttribute('aria-pressed', 'true');
        return node;
      })
      .catch(function () {
        return null;
      });
  }

  function paintPage(loading) {
    var count = grid.children.length;
    var counter = page.querySelector('[data-wishlist-count]');
    var empty = count === 0 && !loading;
    page.querySelector('[data-wishlist-loading]').hidden = !loading;
    page.querySelector('[data-wishlist-empty]').hidden = !empty;
    page.querySelector('[data-wishlist-suggestions]').hidden = !empty;
    page.querySelector('[data-wishlist-note]').hidden = count === 0;
    grid.hidden = count === 0;
    counter.hidden = count === 0;
    counter.textContent = count === 1 ? counter.getAttribute('data-one') : counter.getAttribute('data-other').replace('%n', count);
  }

  function syncPage() {
    var list = read();
    all('[data-wishlist-handle]', grid).forEach(function (tile) {
      if (list.indexOf(tile.getAttribute('data-wishlist-handle')) === -1) grid.removeChild(tile);
    });
    var missing = list.filter(function (handle) {
      return !tileFor(handle) && !pending[handle];
    });
    paintPage(missing.length > 0 && grid.children.length === 0);
    if (!missing.length) return;

    missing.forEach(function (handle) {
      pending[handle] = true;
    });
    Promise.all(missing.map(fetchTile)).then(function (tiles) {
      var current = read();
      /* newest saved first */
      missing.forEach(function (handle, index) {
        delete pending[handle];
        var tile = tiles[index];
        if (tile && current.indexOf(handle) > -1 && !tileFor(handle)) grid.insertBefore(tile, grid.firstChild);
      });
      paintPage(false);
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-wish]')) return;
    /* theme.js stores the change in the same click; read it right after */
    setTimeout(function () {
      paintHeader();
      if (page) syncPage();
    }, 0);
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    paintHeader();
    if (page) syncPage();
  });

  paintHeader();
  if (page) syncPage();
})();
